/**
 * Header/navigation
 */

// Assuming site header is fixed, add a class to indicate when it's "stuck"
const siteHeader = document.querySelector(".site-header");
const siteHeaderPinnedThreshold = 20; // threshold in pixels that we'll switch to pinned
let siteHeaderScrollTimeoutId = 0;
window.addEventListener(
    "scroll",
    () => {
        siteHeaderScrollTimeoutId && window.cancelAnimationFrame(siteHeaderScrollTimeoutId);
        siteHeaderScrollTimeoutId = window.requestAnimationFrame(() => {
            siteHeader.classList.toggle("site-header--is-pinned", window.scrollY > siteHeaderPinnedThreshold);
        });
    },
    false
);

// When clicking on a primary nav link, close the mobile menu
// (because on this site, many of the nav links are anchor links)
// Also, trigger the nav pinned style as soon as we click a link
const navStatusElement = document.querySelector(".site-header__mobile-nav-status");
const siteNavlinks = document.querySelector(".site-header__nav-links");
siteNavlinks.addEventListener("click", (e) => {
    navStatusElement.checked = false;
});

/**
 * Animated Images in columns
 */

const animatedImageContainers = document.querySelectorAll(".has-animated-image");
if (animatedImageContainers.length > 0) {
    for (animatedImageContainer of animatedImageContainers) {
        let animatedImage = animatedImageContainer.querySelector("img[src$=gif");
        let staticImage = animatedImageContainer.querySelector("img:not(img[src$=gif])");

        staticImage?.addEventListener("mouseenter", () => {
            staticImage.classList.add("inactive");
            animatedImage?.classList.add("active");
        });

        animatedImage?.addEventListener("mouseleave", () => {
            animatedImage.classList.remove("active");
            staticImage?.classList.remove("inactive");
        });
    }
}

/**
 * Carousel
 */

import Flickity from "flickity";
import "flickity-imagesloaded";
const carousels = document.querySelectorAll(".wp-block-carousel");
if (carousels.length > 0) {
    for (carousel of carousels) {
        let carouselSlides = carousel.querySelector(".wp-block-carousel__slides");
        let flickity = new Flickity(carouselSlides, {
            cellAlign: "left",
            wrapAround: true,
        });
    }
}
